import { useContext } from "react";
import { GlobalContext } from "../../context/GlobalContext";

import Spinner from "../../assets/Spinner.svg";
import './Loader.scss';


function Loader() {
    const { state }: any = useContext(GlobalContext);
    const { loading } = state

    if (!loading) return null;
    return (
        <div className='loader-container'>
            <div className='loader'>
                <img src={Spinner} alt='spinner' />
            </div>
        </div>
    )
}

export default Loader;